import { render, staticRenderFns } from "./GroupTypeHeader.vue?vue&type=template&id=d0e63060&scoped=true&"
import script from "./GroupTypeHeader.vue?vue&type=script&lang=js&"
export * from "./GroupTypeHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0e63060",
  null
  
)

export default component.exports